module.exports = __webpack_public_path__ + "img/bottomInfo.a7f1b971.png";